import { Stack, Pagination } from "@mui/material";
import Div from "../../../components/Div";
import Input from "../../../components/Input";
import { useState, useEffect, useCallback } from "react";
import PageTitle from "../../../components/PageTitle";
import FormButton from "../../../components/FormButton";
import {
  get_jnr_domain_data,
} from "../../../http/HostingHttp";
import JNRSendNotificationModal from "../../../components/Renewal/JNRSendNotificationModal";

export default function GetJNRDomainData() {
  const [customerList, setCustomerList] = useState([]);
  // const [isAscending, setIsAscending] = useState(true);
  const [initailCustomerList, setInitialCustomerList] = useState([]);
  const [sendNotification, setSendNotification] = useState(false);

  const getCurrentYearMonth = () => {
    const date = new Date();
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}`;
  };

  const [month, setMonth] = useState(getCurrentYearMonth);

  const currentMonth = new Date().toLocaleString("en-US", { month: "long" });
  const [formattedMonth, setFormattedMonth] = useState(currentMonth);

  const [search, setSearch] = useState("");

  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = customerList.slice(indexOfFirstItem, indexOfLastItem);

  // Calculate total pages
  const totalPages = Math.ceil(customerList.length / itemsPerPage);

  // Change page
  const paginate = (event, value) => {
    setCurrentPage(value);
  };



  const getJnrDomainData = useCallback(async () => {
    const response = await get_jnr_domain_data();

    if (response) {
      console.log("JNR Domain Data:", response);
      const date = new Date();
      const currentYearMonth = `${date.getFullYear()}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}`;

      const filteredList = response.domains.filter((customer) => {
        if (customer && customer.renewal_date) {
          return customer.renewal_date.toLowerCase().includes(currentYearMonth.toLowerCase());
        }
        return false;
      });

      setCustomerList(filteredList);
      setInitialCustomerList(response.domains);
    } else {
      setCustomerList([]);
      setInitialCustomerList([]);
    }
  }, []);


  useEffect(() => {
    getJnrDomainData();
  }, [getJnrDomainData]);



  function handleSendNotification(
    domain_name,
    renewal_id,
    subscription_id,
    renewal_date,
    email
  ) {
    const notifyData = {
      domain_name: domain_name,
      product_type: renewal_id,
      subscription_id: subscription_id,
      renewal_date: renewal_date,
      email: email,
    };
    setSendNotification(notifyData);
  }


  function handleMonthChange(event) {
    const month_item = event.target.value;
    console.log(month_item);
    // getJnrDomainData(month_item);
    console.log(month_item)
    let [year, month] = month_item.split("-").map(Number);

    const filteredList = initailCustomerList.filter((customer) => {
      if (customer && customer.renewal_date) {
        return customer.renewal_date
          .toLowerCase()
          .includes(month_item.toLowerCase());
      } else {
        return false;
      }
    });
    setCustomerList(filteredList)

    // Adjust month (subtracting 1 to get the previous month)
    let prevMonthDate = new Date(year, month - 1); // `month - 2` because JS months are 0-based
    setFormattedMonth(prevMonthDate.toLocaleString("en-US", { month: "long" }));
    setMonth(month_item);
  }


  function handleSearchCustomer(event) {
    const search_item = event.target.value;

    console.log(search_item);
    const filteredList = initailCustomerList.filter((customer) => {
      if (customer && customer.domain_name) {
        return customer.domain_name
          .toLowerCase()
          .includes(search_item.toLowerCase());
      } else {
        return false;
      }
    });
 
    setCustomerList(filteredList);
    setSearch(search_item);
  }


  return (
    <>

      {sendNotification ? (
        <JNRSendNotificationModal
          notify={sendNotification}
          show={true.toString()}
          open
          handleClicked={setSendNotification}
        />
      ) : null}

      <PageTitle title={`JNR Renewal Data for ${formattedMonth}`} />
      <Div className="col-md-12">
        <Div className="page-header-toolbar">
          <Div className="btn-group toolbar-item" role="group">
            <Input
              type="month"
              name="month"
              id="month"
              style={{ marginLeft: "50px" }}
              value={month}
              onChange={handleMonthChange}
            />
          </Div>

          <Div className="btn-group toolbar-item" role="group">
            <Input
              type="text"
              name="text"
              id="text"
              style={{ marginLeft: "50px" }}
              value={search}
              onChange={handleSearchCustomer}
            />

         
          </Div>



          <Div className="filter-wrapper"></Div>
        
        </Div>
      </Div>

      <Div className="col-md-12 margin_top" style={{ opacity: "0.9" }}>
        {initailCustomerList.length > 0 ? (
          <table className="table" border="1">
            <thead>
              <tr>
                <th>Domain Name</th>
                <th>Product</th>
                <th>Date</th>
                <th>Renewal Date</th>
                <th>Customer Email</th>
                <th>Product Type</th>
                <th></th>
              </tr>
            </thead>
            <tbody id="tableBody">
              {currentItems.map((customer) => (
                <tr key={customer.domain_uuid}>
                  <td>
                    {customer.domain_name}
                  </td>
                  <td>{customer.product}</td>
                  <td>{customer.date}</td>
                  <td>{customer.renewal_date}</td>
                  <td>{customer.customer_email}</td>
                  <td>{customer.product_type}</td>
                  <td>
                    <FormButton
                      type='button'
                      className="btn btn-link"
                      onClick={() => handleSendNotification(customer.domain_name, customer.product,
                        customer.date, customer.renewal_date, customer.customer_email)}
                    >{customer.notification_status ? 'Sent Notification' : 'Send Notification'}</FormButton>
                 
                  </td>

                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <>
            <p style={{ marginTop: "30px" }}>
              No Domain Present or Could not fetch Domains
            </p>
          </>
        )}

        {currentItems.length > 0 ? (
          <Stack spacing={2}>
            <Pagination
              count={totalPages}
              color="primary"
              page={currentPage}
              onChange={paginate}
            ></Pagination>
          </Stack>
        ) : null}
      </Div>
    </>
  );
}
